/**
 * Renders the amp markup for the component. We DO not use the arrow style so that we can have access to this.
 */
function renderAmp() {
  return null;
}

export default renderAmp;
